export default __webpack_public_path__ + "static/media/guadalajara.1cd0fb78.png";